export const FACILITY_USER_ACCESS_MODE = Object.freeze({
  ALL_FACILITIES: 'all_facilities',
  FACILITY_GROUPS: 'facility_groups',
  DIRECT_FACILITIES: 'direct_facilities',
  NONE: 'none',
});
